<ion-header>
  <ion-toolbar class="header-toolbar">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/auth"></ion-back-button>
    </ion-buttons>
    <ion-title>{{ 'CRUD_DETAILS_INFO.TITLE' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <br />
  <div class="ion-text-center">
    <img src="assets/icon/colors/customer.svg" alt="Customer" width="90" />
    <div class="ion-padding">
      <br />
      <span style="color: var(--ion-color-tertiary)">
        {{ 'CRUD_DETAILS_INFO.MESSAGE' | translate }}
      </span>
    </div>
  </div>
  @if (crudInfo$ | async; as crudInfo) {
    <ion-card>
      <ion-card-header class="align-card-in-row">
        <ion-icon class="icon-padding" name="person-outline"></ion-icon>
        <span>{{ 'CRUD_DETAILS_INFO.OWNER' | translate }}</span>
      </ion-card-header>
      <ion-card-content>
        <ion-item lines="none">
          <ion-label class="label" labelPlacement="stacked">
            {{ 'CRUD_DETAILS_INFO.FULL_NAME' | translate }}
          </ion-label>
          <ion-text>{{ crudInfo?.ownerCenterInfo?.fullName }}</ion-text>
        </ion-item>
        <ion-item lines="none">
          <ion-label class="label" labelPlacement="stacked">
            {{ 'CRUD_DETAILS_INFO.SSN' | translate }}
          </ion-label>
          <ion-text>{{ crudInfo?.ownerCenterInfo?.cpf }}</ion-text>
        </ion-item>
        <ion-item lines="none">
          <ion-label class="label" labelPlacement="stacked">
            {{ 'CRUD_DETAILS_INFO.BIRTHDATE' | translate }}
          </ion-label>
          <ion-text>{{ crudInfo?.ownerCenterInfo?.birthDate | date: 'dd/MM/yyyy' }}</ion-text>
        </ion-item>
        <ion-item lines="none">
          <ion-label class="label" labelPlacement="stacked">
            {{ 'CRUD_DETAILS_INFO.EMAIL' | translate }}
          </ion-label>
          <ion-text>{{ crudInfo?.ownerCenterInfo?.email }}</ion-text>
        </ion-item>
        <ion-item lines="none">
          <ion-label class="label" labelPlacement="stacked">
            {{ 'CRUD_DETAILS_INFO.CELLPHONE' | translate }}
          </ion-label>
          <ion-text>{{ crudInfo?.ownerCenterInfo?.cellphone }}</ion-text>
        </ion-item>
      </ion-card-content>
    </ion-card>
    <ion-card>
      <ion-card-header class="align-card-in-row">
        <ion-icon class="icon-padding" name="home-outline"></ion-icon>
        <span>{{ 'CRUD_DETAILS_INFO.ADDRESS' | translate }}</span>
      </ion-card-header>
      <ion-card-content>
        <ion-item lines="none">
          <ion-label class="label">{{ 'CRUD_DETAILS_INFO.STREET_AVENUE' | translate }}</ion-label>
          <ion-text>{{ crudInfo.addressInfo?.logradouro }}</ion-text>
        </ion-item>
        <ion-item lines="none">
          <ion-label class="label">{{ 'CRUD_DETAILS_INFO.NUMBER' | translate }}</ion-label>
          <ion-text>{{ crudInfo.addressInfo?.number }}</ion-text>
        </ion-item>
        <ion-item lines="none">
          <ion-label class="label">{{ 'CRUD_DETAILS_INFO.COMPLEMENT' | translate }}</ion-label>
          <ion-text>{{ crudInfo.addressInfo?.complement }}</ion-text>
        </ion-item>
        <ion-item lines="none">
          <ion-label class="label">{{ 'CRUD_DETAILS_INFO.CITY' | translate }}</ion-label>
          <ion-text>{{ crudInfo.addressInfo?.district }}</ion-text>
        </ion-item>
        <ion-item lines="none">
          <ion-label class="label">{{ 'CRUD_DETAILS_INFO.STATE' | translate }}</ion-label>
          <ion-text>{{ crudInfo.addressInfo?.state }}</ion-text>
        </ion-item>
        <ion-item lines="none">
          <ion-label class="label">{{ 'CRUD_DETAILS_INFO.ZIP_CODE' | translate }}</ion-label>
          <ion-text>{{ crudInfo.addressInfo?.cep }}</ion-text>
        </ion-item>
        <ion-item lines="none">
          <ion-label class="label">{{ 'CRUD_DETAILS_INFO.COUNTRY' | translate }}</ion-label>
          <ion-text>{{ crudInfo.addressInfo?.country }}</ion-text>
        </ion-item>
      </ion-card-content>
    </ion-card>
    <ion-card>
      <ion-card-header class="align-card-in-row">
        <ion-icon class="icon-padding" name="person-circle-outline"></ion-icon>
        <span>{{ 'CRUD_DETAILS_INFO.USER' | translate }}</span>
      </ion-card-header>
      <ion-card-content>
        <ion-item lines="none">
          <ion-label class="label">{{ 'CRUD_DETAILS_INFO.USERNAME' | translate }}</ion-label>
          <ion-text>{{ crudInfo?.userInfo?.username }}</ion-text>
        </ion-item>
        <ion-item lines="none">
          <ion-text color="tertiary">
            <span>{{ 'CRUD_DETAILS_INFO.PASSWORD_NOTE' | translate }}</span>
            <span>({{ crudInfo?.ownerCenterInfo?.email }})</span>
          </ion-text>
        </ion-item>
      </ion-card-content>
    </ion-card>
  }
  <div class="ion-padding">
    <ion-button
      class="custom-button"
      [disabled]="(isLoading$ | async) === true"
      expand="block"
      color="tertiary"
      (click)="register()"
      (keypress)="register()">
      <span>{{ 'CRUD_DETAILS_INFO.REGISTER' | translate }}</span>
      <img alt="Piont" src="assets/icon/whites/point.svg" width="25" slot="end" />
      @if ((isLoading$ | async) === true) {
        <ion-spinner name="dots"></ion-spinner>
      }
    </ion-button>
  </div>
</ion-content>
